import * as React from 'react'
import cx from 'classnames'
import styles from './ResultCounts.sass'

interface ResultCountsProps {
  showing: number
  total: number | null
}

export default function ResultCounts({ showing, total }: ResultCountsProps) {
  total = total === null ? 0 : Math.max(total, showing)
  return (
    <span className={cx(styles.root)}>
      Showing <strong className={styles.value}>{showing}</strong>
      {total > 0 && (
        <>
          {' '}
          of <strong className={styles.value}>{total}</strong>
        </>
      )}{' '}
      results
    </span>
  )
}
